<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사용자관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사용자 수정</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                사용자 수정 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">사용자 아이디</th>
                  <td colspan="3">
                    <div class="flex">
                      <input
                        type="text"
                        v-model="empNo"
                        @input="resetUsedCnt"
                        maxlength="20"
                        class="small2"
                        title="사용자아이디 입력"
                        readonly
                      />
                      <!-- <button type="button" class="btn gray" @click="OverlapBtn">중복확인</button> -->
                    </div>
                    <p v-if="usedCnt === 1" class="reference orange">중복된 아이디입니다.</p>
                    <p v-if="usedCnt === 0" class="reference orange">사용 가능한 아이디입니다.</p>
                    <div class="error" v-if="idReq">필수 입력란입니다.</div>
                    <div class="error" v-if="idRegex">
                      조건에 맞지 않습니다. ※5~20자의 영문 소문자, 숫자와 특수문자 -, _ 만 사용 가능합니다.
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비밀번호</th>
                  <td>
                    <input
                      type="password"
                      v-model="password"
                      title="비밀번호 입력"
                      placeholder="영문,숫자,특수문자 조합 8-20자리"
                    />
                    <div class="error" v-if="pwReqChk">필수 입력란입니다.</div>
                    <div class="error" v-if="pwMinChk">8-20자리 입력란입니다.</div>
                    <div class="error" v-if="pwMaxChk">8-20자리 입력란입니다.</div>
                    <div class="error" v-if="pwRegexChk">
                      조건에 맞지 않습니다.<br />※ 숫자,영문자,특수문자(!,@,#,$,%,&,*,? 만 사용 가능합니다.)
                    </div>
                  </td>
                  <th scope="row">비밀번호 확인</th>
                  <td>
                    <input
                      type="password"
                      v-model="passwordCon"
                      title="비밀번호 재입력"
                      placeholder="영문,숫자,특수문자 조합 8-20자리"
                    />
                    <div class="error" v-if="pwConReqChk">필수 입력란입니다.</div>
                    <div class="error" v-if="pwConSame">일치하지 않는 비밀번호입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">이름</th>
                  <td>
                    <input type="text" title="이름 입력" v-model="empNm" />
                  </td>
                  <th scope="row">사용자 상태</th>
                  <td>
                    <select name="" id="" title="사용자 상태 선택" v-model="empSttus">
                      <option value="P">승인</option>
                      <option value="D">삭제</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">부서명</th>
                  <td>
                    <select name="" id="" title="부서명 선택" v-model="deptId">
                      <option :key="i" :value="dept.deptId" v-for="(dept, i) in deptList">
                        {{ dept.deptNm }}
                      </option>
                    </select>
                  </td>
                  <th scope="row">팀명</th>
                  <td>
                    <select name="" id="" title="팀명 선택" v-model="teamId">
                      <option :key="i" :value="team.teamId" v-for="(team, i) in teamList">
                        {{ team.teamNm }}
                      </option>
                    </select>
                  </td>
                </tr>
                <!-- <tr>
                  <th scope="row">업무구분</th>
                  <td colspan="3">
                    <select name="" v-model="jobId" id="" title="업무구분 선택" class="middle">
                      <option :key="i" :value="{ id: job.code, text: job.nm }" v-for="(job, i) in jobList">
                        {{ job.nm }}
                      </option>
                    </select>
                  </td>
                </tr> -->
                <!-- <tr>
                  <th scope="row">근무지역</th>
                  <td colspan="3">
                    <div class="flex">
                      <select name="" id="" title="근무지역 선택" class="w170">
                        <option value="">선택</option>
                      </select>
                      <select name="" id="" title="근무지역 선택" class="w170">
                        <option value="">선택</option>
                      </select>
                    </div>
                  </td>
                </tr> -->
                <tr>
                  <th scope="row">휴대폰번호</th>
                  <td>
                    <div class="tell">
                      <input type="text" maxlength="4" title="휴대폰 앞 3자리 입력" v-model="firstNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input type="text" maxlength="4" title="휴대폰 앞 4자리 입력" v-model="secondNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input type="text" maxlength="4" title="휴대폰 뒤 4자리 입력" v-model="lastNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                  </td>
                  <th scope="row">전화번호</th>
                  <td>
                    <div class="tell">
                      <input type="text" maxlength="4" title="전화번호 국번 입력" v-model="firstTelNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input type="text" maxlength="4" title="전화번호 앞 4자리 입력" v-model="secondTelNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input type="text" maxlength="4" title="전화번호 뒤 4자리 입력" v-model="lastTelNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">이메일주소</th>
                  <td colspan="3">
                    <input type="text" title="이메일주소 입력" class="middle" v-model="empEmail"/>
                  </td>
                </tr>
                <tr>
                  <th scope="row">사용자 권한</th>
                  <td colspan="3">
                    <select name="" id="" title="사용자 권한 선택" class="middle" v-model="authorCd">
                      <option :key="i" :value="auth.authorCode" v-for="(auth,i) in authorManageList">
                          {{ auth.authorNm }}
                      </option>
                    </select>
                  </td>
                </tr>
                <!-- <tr>
                  <th scope="row">단말기 아이디</th>
                  <td colspan="3">
                    <input type="text" title="단말기 아이디 입력" class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">단말기 전화번호</th>
                  <td colspan="3">
                    <input type="text" title="이메일주소 입력" class="md" />
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <!-- <button class="btn border" @click="$router.push('usermanagement')">목록</button> -->
          <button class="btn gray" @click="$router.push('usermanagement')">취소</button>
          <button class="btn blue" @click="insertBtn">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import { required, sameAs, helpers, minLength, maxLength } from 'vuelidate/lib/validators';
const idRegex = helpers.regex('idRegex', /^[A-Za-z]{0}[A-Za-z0-9_-]{5,20}$/);
const passRegex = helpers.regex('passRegex', /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/gi);

export default {
  data() {
    return {
      empNo: '',
      empNm: '',
      usedCnt: -1,
      password: '',
      passwordCon: '',
      submitStatus: '',
      deptList: [],
      teamList: [],
      empSttus: 'P',
      deptId: '',
      teamId: '',
      empTelNo: '',
      empMobile: '',
      empEmail: '',
      authorManageList: [],
      authorCd: '',
      jobList: [],
      jobId: '',
      pwReqChk: false,
      pwRegexChk: false,
      pwMaxChk: false,
      pwMinChk: false,
      pwConReqChk: false,
      pwConSame: false,
      idReq: false,
      idRegex: false,
      firstNumber: '',
      secondNumber: '',
      lastNumber: '',
      firstTelNumber: '',
      secondTelNumber: '',
      lastTelNumber: '',
      empEsntlId: '',
    };
  },

  validations: {
    empNo: {
      required,
      idRegex: idRegex,
    },
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      passRegex: passRegex,
    },
    passwordCon: {
      required,
      sameAsPassword: sameAs('password'),
      minLength: minLength(8),
      maxLength: maxLength(20),
    },
  },

  created() {
    const data = this.$route.params.data;
    if(!data) {
      this.$router.go(-1);
      return;
    }
    this.empNo = data.empNo;
    this.deptId = data.empDeptCd;
    this.teamId = data.empTeamCd;
    this.authorCd = data.empAuthCd;
    this.empNm = data.empNm;
    if(data.empMobile) {
      this.firstNumber = data.empMobile.slice(0,3);
      this.secondNumber = data.empMobile.slice(3,7);
      this.lastNumber = data.empMobile.slice(7,data.empMobile.length);
    }
    if(data.empTelNo) {
      if(data.empTelNo.length == 10) {
        if(data.empTelNo.slice(0,2) == '02') {
          this.firstTelNumber = data.empTelNo.slice(0,2);
          this.secondTelNumber = data.empTelNo.slice(2,6);
          this.lastTelNumber = data.empTelNo.slice(6,data.empTelNo.length);
        }else {
          this.firstTelNumber = data.empTelNo.slice(0,3);
          this.secondTelNumber = data.empTelNo.slice(3,6);
          this.lastTelNumber = data.empTelNo.slice(6,data.empTelNo.length);
        }
      }else {
        if(data.empTelNo.slice(0,2) == '02') {
          this.firstTelNumber = data.empTelNo.slice(0,2);
          this.secondTelNumber = data.empTelNo.slice(2,5);
          this.lastTelNumber = data.empTelNo.slice(5,data.empTelNo.length);
        }else {
          this.firstTelNumber = data.empTelNo.slice(0,3);
          this.secondTelNumber = data.empTelNo.slice(3,7);
          this.lastTelNumber = data.empTelNo.slice(7,data.empTelNo.length);
        }
      }
    }
    this.empEmail = data.empEmail;
    this.empEsntlId = data.empEsntlId;
  },

  mounted() {
    this.init();
  },

  methods: {
    resetUsedCnt() {
      this.usedCnt = -1;
    },
    // async OverlapBtn() {
    //   if (this.$v.empNo.$invalid) {
    //     return;
    //   }
    //   const res = await axios('get', '/api/member/idDplctCnfirmAjax.json', {
    //     checkId: this.empNo,
    //   });
    //   this.usedCnt = res.data.usedCnt;
    // },

    // idValidation() {
    //   if (this.usedCnt === -1) {
    //     alert('아이디 중복검사를 해주십시오.');
    //     return false;
    //   } else if (this.usedCnt === 1) {
    //     alert('중복된 아이디입니다.');
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },

    async init() {
      const urls = ['/api/dept/list.json', '/api/team/list.json', '/api/auth/authorGroupList.json'];
      const req = urls.map(url => axios('get', url));
      const res = await Promise.all(req);
      const [deptList, teamList, authorManageList] = await Promise.all(res);

      this.deptList = deptList.data.resultList;
      this.teamList = teamList.data.resultList;
      this.authorManageList = authorManageList.data.authorManageList;
    },

    // async getJobList() {
    //   const res = await axios('get', '/api/code/codeNmList.json', {
    //     codeTy: 'JOB',
    //   });
    //   const data = res.data;
    //   this.jobList = data.resultList;
    // },

    async insertBtn() {
      if (this.$v.$invalid) {
        if(!this.$v.password.required) this.pwReqChk = !this.pwReqChk;
        if(!this.$v.password.passRegex) this.pwRegexChk = !this.pwRegexChk;
        if(!this.$v.password.maxLength) this.pwMaxChk = !this.pwMaxChk;
        if(!this.$v.password.minLength) this.pwMinChk = !this.pwMinChk;
        if(!this.$v.passwordCon.required) this.pwConReqChk = !this.pwConReqChk;
        if(!this.$v.passwordCon.sameAsPassword) this.pwConSame = !this.pwConSame;
        if(!this.$v.empNo.required) this.idReq = !this.idReq;
        if(!this.$v.empNo.idRegex) this.idRegex = !this.idRegex;
        return;
      }
      let apiParams = new FormData();
      apiParams.append('empNo', this.empNo);
      apiParams.append('empNm', this.empNm);
      apiParams.append('password', this.password);
      apiParams.append('empMobile', this.firstNumber + this.secondNumber + this.lastNumber);
      apiParams.append('empTelNo', this.firstTelNumber + this.secondTelNumber + this.lastTelNumber);
      apiParams.append('empEmail', this.empEmail);
      apiParams.append('empDeptCd', this.deptId);
      apiParams.append('empTeamCd', this.teamId);
      apiParams.append('authCode', this.authorCd);
      apiParams.append('empSttus', this.empSttus);
      apiParams.append('empEsntlId', this.empEsntlId);
      // apiParams.append('empDutyCd', this.jobId);

      const res = await axios('post', '/api/member/updateAction.json', apiParams);
      const message = res.data.message;
      alert(message);
      this.$router.push('usermanagement');
    },
  },

  goBack() {
    this.$router.go(-1);
    localStorage.clear();
  },

  goBackConfirm() {
    this.$confirm({
      message: `취소하시겠습니까?`,
      button: {
        no: '아니오',
        yes: '예',
      },
      callback: confirm => {
        if (confirm) {
          this.goBack();
        }
      },
    });
  },
};
</script>
